// Translations for the Loans page (Loans.js).
const loansDict = [
  { en: "Loans Management", sw: "Usimamizi wa Mikopo" },
  { en: "Applications, approvals, disbursements and balances", sw: "Maombi, idhini, utoaji na salio la mikopo" },
  { en: "New Loan Application", sw: "Ombi Jipya la Mkopo" },
  { en: "Total Loans", sw: "Jumla ya Mikopo" },
  { en: "Total Disbursed", sw: "Jumla Iliyotolewa" },
  { en: "Outstanding", sw: "Kiasi kinachodaiwa" },
  { en: "Pending Review", sw: "Inasubiri Kupitiwa" },
  { en: "All Loans", sw: "Mikopo Yote" },
  { en: "Pending", sw: "Inasubiri" },
  { en: "Loan #", sw: "Namba ya Mkopo" },
  { en: "Member", sw: "Mwanachama" },
  { en: "Amount", sw: "Kiasi" },
  { en: "Interest", sw: "Riba" },
  { en: "Balance", sw: "Salio" },
  { en: "Status", sw: "Hali" },
  { en: "Actions", sw: "Vitendo" },
  { en: "Approve", sw: "Idhinisha" },
  { en: "Reject", sw: "Kataa" },
  { en: "Disburse", sw: "Toa Fedha" },
  { en: "Member ID", sw: "Kitambulisho cha Mwanachama" },
  { en: "Amount (TZS)", sw: "Kiasi (TZS)" },
  { en: "Tenure (Months)", sw: "Muda (Miezi)" },
  { en: "Interest Rate (%)", sw: "Kiwango cha Riba (%)" },
  { en: "Purpose", sw: "Madhumuni" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Submit Application", sw: "Wasilisha Maombi" },
  { en: "Approve this loan application?", sw: "Je, unaidhinisha ombi hili la mkopo?" },
  { en: "Reject this loan application?", sw: "Je, unakataa ombi hili la mkopo?" },
];

export default loansDict;
